function regularContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 * contractData.closeSharePrice).toFixed(2));
}

function noContractPrice(contractData) {
  if (contractData.closeSharePrice === null) return null;
  return Number((100 - (contractData.closeSharePrice * 100)).toFixed(2));
}

export {
  regularContractPrice,
  noContractPrice,
};



// WEBPACK FOOTER //
// ./src/components/market/market-detail-charts/utils.js